module.exports = __webpack_public_path__ + "img/Steor-Icons-22.2c0ffe26.svg";